<script lang="ts">
  import { parseUtcInputValue, toUtcInputValue } from '../lib/time';
  import type { ComparisonMode, Monitor, WorkspaceState } from '../lib/types';

  export let workspace: WorkspaceState;
  export let monitors: Monitor[];
  export let comparisonMode: ComparisonMode;
  export let onGlobalMonitor: (monitorId: string) => void;
  export let onRange: (range: [number, number]) => void;
  export let onResetRange: () => void;
  export let onComparisonMode: (comparisonMode: ComparisonMode) => void;
  export let analysisOpen = false;
  export let onToggleAnalysis: () => void = () => undefined;

  function setRange(index: 0 | 1, value: string) {
    const timestamp = parseUtcInputValue(value);
    if (timestamp == null) return;
    const next: [number, number] = [...workspace.range];
    next[index] = timestamp;
    if (next[0] < next[1]) onRange(next);
  }

</script>

<section class="workspace-controls" aria-labelledby="workspace-controls-heading">
  <div class="comparison-bar" aria-label="Comparison controls">
    <h2 id="workspace-controls-heading">Controls</h2>
    <span id="comparison-mode-label" class="comparison-bar__label">Comparison mode</span>
    <div class="segmented" role="group" aria-labelledby="comparison-mode-label">
      <button class:active={comparisonMode === 'same-location'} aria-pressed={comparisonMode === 'same-location'} type="button" on:click={() => onComparisonMode('same-location')}>Same location</button>
      <button class:active={comparisonMode === 'multiple-locations'} aria-pressed={comparisonMode === 'multiple-locations'} type="button" on:click={() => onComparisonMode('multiple-locations')}>Multiple locations</button>
    </div>
    <button
      class="button comparison-bar__analysis-toggle"
      type="button"
      aria-expanded={analysisOpen}
      aria-controls="workspace-analysis"
      on:click={onToggleAnalysis}
    >{analysisOpen ? 'Hide analysis' : 'Show analysis'}</button>
  </div>

  <div class:workspace-controls__fields--range-only={comparisonMode === 'multiple-locations'} class="workspace-controls__fields">
    {#if comparisonMode === 'same-location'}
      <label class="control-row control-row--location">
        <span>Monitoring location</span>
        <select value={workspace.globalMonitorId} on:change={(event) => onGlobalMonitor((event.currentTarget as HTMLSelectElement).value)}>
          {#each monitors as monitor (monitor.monitor_name_index)}
            <option value={monitor.monitor_name_index}>{monitor.primary_name}, {monitor.monitor_name_formatted} ({monitor.total_days} days)</option>
          {/each}
        </select>
      </label>
    {/if}

    <div class="range-controls">
      <label>Range start (UTC)
        <input type="datetime-local" step="1" value={toUtcInputValue(workspace.range[0])} on:change={(event) => setRange(0, (event.currentTarget as HTMLInputElement).value)} />
      </label>
      <label>Range end (UTC)
        <input type="datetime-local" step="1" value={toUtcInputValue(workspace.range[1])} on:change={(event) => setRange(1, (event.currentTarget as HTMLInputElement).value)} />
      </label>
      <button class="button" type="button" on:click={onResetRange} title="Reset the shared range to the global location's full data range">Reset range</button>
    </div>
  </div>
</section>
